export const calculateMonthlyPayment = (args: number[]) => {
  const loanAmount = args[0];
  const tenure = args[1] * 12;
  const interestRate = args[2] / 12;

  const monthlyPayment =
    loanAmount /
    ((Math.pow(1 + interestRate, tenure) - 1) /
      (interestRate * Math.pow(1 + interestRate, tenure)));
  return Math.ceil(monthlyPayment);
};
